<template>
    <div class="marketing-info pa-6">
  <v-card v-if="item">
        <v-app-bar flat >
          <v-icon>mdi-newspaper</v-icon>
          <v-toolbar-title class="title pl-1">
            {{$t('global.news')}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-app-bar>

           <v-img
             max-height="400"
             class="white--text align-end "
             :key="getItemImageKey(item)"
             :src="getImageUrlByObject(item)"
             @click="showHandler(item)"
           >
           <v-card-title class="primary--text black " >
             <span v-if="language == 'fr'">{{ item.namefr }}</span>
             <span v-else>{{ item.name }}</span>
             <v-spacer></v-spacer>
             <v-btn  class="" icon >
               <v-icon>mdi-launch</v-icon>
             </v-btn>
           </v-card-title>

            </v-img>
            <div v-if="item.file" class="iframe_container">
              <iframe  :src="blobFile" class="iframe_responsive"></iframe>
            </div>
            
            



      </v-card>
  </div>




</template>


<script>
import i18n from '../../i18n.js';
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import FileMixin from '../../mixins/FileMixin';


const servicePrefix = 'Article';

export default {
  name: 'ArticleShow',
  servicePrefix,
  components: {

  },
  data: () => ({
    filter: '1280x700',
  }),
  mixins: [ShowMixin,AccessMixin,FileMixin],
  computed: {
    ...mapFields('article', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('article', ['find']),
    language() {
      return i18n.locale;
    }
  },
  methods: {
    ...mapActions('article', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    }),
    showHandler(item) {
      if (item.file) {
        //this.downloadFileByObject(item);
        window.open(this.blobFile, "_blank");
      }
      else if (this.language == 'fr') {
        window.open(item.linkfr, "_blank");
      } else {
        window.open(item.link, "_blank");
      }
      

    },
  },
  watch: {
    item() {
      if (this.item.file) {
        this.downloadFileBlobByObject(this.item);
      }
    }
  }
};
</script>
<style>
.iframe_container {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
}

/* Then style the iframe to fit in the container div with full height and width */
.iframe_responsive {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
</style>
